import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'

type HiddenRouteProps = {
  hidden: boolean
  redirectTo: string
}

export default function HiddenRoute({ hidden, redirectTo }: HiddenRouteProps): JSX.Element {
  if (hidden) {
    return <Navigate to={redirectTo} replace />
  }

  return <Outlet />
}
